export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8360.e4a78d1f.jpg";